import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { AchievementWrapper, ImageWrapper, ProgressBarWrapper, RuleWrapper, Wrapper } from './wrappers';
import { ColumnWrapper, Mt5, Mt2, TextCenterWrapper } from 'wrappers';
import { Label, AchievementElement } from 'molecules';
import { Icon, SecondaryTextXlBold, SecondaryTextLgBold, SecondaryTextXs, ProgressBar, SecondaryTextXs300 } from 'atoms';
import { format } from 'date-fns';
import getIsMobile from 'components/atoms/utils/getIsMobile';
import { getObjectIcons } from 'utils';

const isMobile = getIsMobile();

export const definition = {
  name: "BadgeCard",
  controller: Controller,
  initialProps: ({ badge }) => ({ badge }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(ColumnWrapper, Wrapper),
      name: 'Info',
      elements: [
        {
          component: wrap(Icon, ImageWrapper),
          name: 'Image',
          renderIf: ({ badge }) => badge.image,
          displayValue: ({ badge }) => getObjectIcons({})[badge.image] ?? getObjectIcons({})['Medal']
        },
        {
          component: isMobile ? wrap(wrap(SecondaryTextLgBold, TextCenterWrapper), Mt5) : wrap(wrap(SecondaryTextXlBold, TextCenterWrapper), Mt5),
          name: 'BadgeName',
          displayValue: ({ badge }) => badge.name ?? ''
        },
        {
          component: wrap(SecondaryTextXs, RuleWrapper),
          name: 'BadgeRule',
          displayValue: ({ badge }) => badge.description
        },
        {
          component: Label,
          name: 'Label',
          renderIf: ({ badge }) => badge.receiveDate,
          bindings: ({ badge }) => ({ active: true, text: `Awarded ${format(badge.receiveDate, 'dd MMM yyy')}` }),
          displayState: ({ }) => ({ active: true })
        },
        {
          wrapper: AchievementWrapper,
          name: 'LeftAssignments',
          renderIf: ({ badge }) => badge.hasStats,
          elements: [
            {
              component: AchievementElement,
              name: 'Achieved',
              bindings: ({ badge }) => ({ count: badge.achieved || 0, name: "achieved", color: '#1DBD6B' }),
            },
            {
              component: AchievementElement,
              name: 'OnTrack',
              bindings: ({ badge }) => ({ count: badge.onTrack || 0, name: "pending", color: "#6457E8" }),
            },
          ]
        },
        {
          wrapper: ProgressBarWrapper,
          name: 'ProgressWrapper',
          elements: [
            {
              component: ProgressBar,
              name: 'ProgressBar',
              renderIf: ({ badge }) => badge.progress,
              displayValue: ({ }) => '',
              displayState: ({ badge }) => ({ progress: badge.progress }),
            },
          ]
        },
        {
          component: wrap(SecondaryTextXs300, Mt2),
          name: 'ProgressText',
          renderIf: ({ badge }) => badge.progress,
          displayValue: ({ badge }) => badge.progressText,
        },
      ]
    },
  ]
}

export default ContainerComponent(definition);
